import React from 'react';
import FloatingHero from '../../../../components/user/general/banner/Banner'
import contactbanner from '../../../../assets/images/home/contactbanner.jpg';
const ContactBanner = () => {
  return (
    <>
      <FloatingHero
        title="Get In Touch"
        subtitle="We're here to help with all your equipment needs"
        backgroundImage={contactbanner}
        darkOverlay={0.75}
      />
      {/* Rest of page content */}
    </>
  );
};

export default ContactBanner;